import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import { styled } from '@mui/material/styles';
import './ConversationalLayout.css';

const StyledSkeleton = styled(Skeleton)({
  background: '#E8E8E8',
  borderRadius: '4px',
});

function ConversationalSkeletonLoader() {
  return (
    <div className="conv-container">
      {/* Progress bar skeleton */}
      <div className="conv-progress-container">
        <div className="conv-progress-wrapper">
          <StyledSkeleton
            variant="rectangular"
            height={6}
            sx={{ borderRadius: '3px', width: '100%' }}
          />
        </div>
      </div>

      {/* Main content area */}
      <div className="conv-content" style={{ animation: 'none' }}>
        <div className="conv-question">
          {/* Question number skeleton */}
          <div className="conv-question-header">
            <StyledSkeleton
              variant="rectangular"
              width={32}
              height={32}
              sx={{ borderRadius: '6px', flexShrink: 0 }}
            />
            <div style={{ flex: 1, marginLeft: 16 }}>
              {/* Question title skeleton */}
              <StyledSkeleton
                variant="rectangular"
                height={36}
                sx={{ borderRadius: '4px', marginBottom: 2, maxWidth: '80%' }}
              />
              {/* Question description skeleton */}
              <StyledSkeleton
                variant="rectangular"
                height={20}
                sx={{ borderRadius: '4px', maxWidth: '60%' }}
              />
            </div>
          </div>

          {/* Answer area skeleton */}
          <div className="conv-answer" style={{ marginTop: 32 }}>
            <StyledSkeleton
              variant="rectangular"
              height={48}
              sx={{ borderRadius: '8px', marginBottom: 2 }}
            />
            <StyledSkeleton
              variant="rectangular"
              height={48}
              sx={{ borderRadius: '8px', marginBottom: 2, maxWidth: '90%' }}
            />
            <StyledSkeleton
              variant="rectangular"
              height={48}
              sx={{ borderRadius: '8px', maxWidth: '75%' }}
            />
          </div>

          {/* Navigation button skeleton */}
          <div className="conv-navigation" style={{ marginTop: 32 }}>
            <StyledSkeleton
              variant="rectangular"
              width={80}
              height={40}
              sx={{ borderRadius: '6px' }}
            />
          </div>
        </div>
      </div>

      {/* Navigation arrows skeleton */}
      <div className="conv-nav-arrows">
        <StyledSkeleton
          variant="rectangular"
          width={40}
          height={40}
          sx={{ borderRadius: '8px', marginBottom: 1 }}
        />
        <StyledSkeleton
          variant="rectangular"
          width={40}
          height={40}
          sx={{ borderRadius: '8px' }}
        />
      </div>
    </div>
  );
}

export default ConversationalSkeletonLoader;
